import {
  GET_CHECKIN_LIST, GET_PROMOTION_LIST, GET_REDEMPTION_LIST, CHANGE_STATUS_PROMOTION, CHANGE_STATUS_REDEMPTION, PROMO_STATUS_UNDEFINED, REDEMP_STATUS_UNDEFINED, GET_CHECKOUT_INFO,
  GET_CHECKOUT_HISTORY, GET_CHECKOUT_HISTORY_SUMMARY, GET_STAFF_BY_SERVICE, CHECKOUT_SUBMIT, CHECK_PHONE, LOGIN, CHANGE_STATUS_SERVICE_SHOW_FULL, CHECK_UPDATE
} from "./checkinTypes";
// import { Checkin } from '../../models/checkin/checkin'
// import { History } from '../../models/checkin/history'
export default {
  [GET_CHECKIN_LIST](state, data) {
    state.checkinList = data;
    let checkin_arr = [];
    // let pending_arr = [];
    // let inservice_arr = [];
    if (data.items) {
      // for(let i = 0; i < data.items.length; i++) {
      //   if(data.items[i].check_out.status == 'pending') {
      //     checkin_arr.push(new Checkin(data.items[i]));
      //   } else {
      //     inservice_arr.push(new Checkin(data.items[i]));
      //   }
      // }
      // for(let i = 0; i < inservice_arr.length; i++) {
      //   checkin_arr.push(inservice_arr[i]);
      // }
      checkin_arr = data.items;
    }
    state.checkinListItems = checkin_arr;
  },

  [CHANGE_STATUS_SERVICE_SHOW_FULL](state, data) {
    if (state.checkinListItems[data.checkin_index] && state.checkinListItems[data.checkin_index].services[data.service_index]) {
      state.checkinListItems[data.checkin_index].services[data.service_index].changeStatusShowFull();
    }
    if (state.checkoutHistoryItems[data.checkin_index] && state.checkoutHistoryItems[data.checkin_index].check_in &&
      state.checkoutHistoryItems[data.checkin_index].check_in.services && state.checkoutHistoryItems[data.checkin_index].check_in.services[data.service_index]) {
      state.checkoutHistoryItems[data.checkin_index].check_in.services[data.service_index].changeStatusShowFull();
    }
  },
  [GET_PROMOTION_LIST](state, data) {
    state.promotionList = data;
  },
  [GET_REDEMPTION_LIST](state, data) {
    state.redemptionList = data;
  },
  [CHECKOUT_SUBMIT](state, data) {
    state.checkoutData = data;
  },
  [CHECK_PHONE](state, data) {
    state.checkinData = data;
  },
  [LOGIN](state, data) {
    state.checkinInfo = data;
  },
  [GET_CHECKOUT_INFO](state, data) {
    // state.checkoutInfo = data;
    for (let i = 0; i < data.list_redeem.length; i++) {
      data.list_redeem[i].checked = undefined;
    }
    // state.checkoutInfo = data;
    for (let i = 0; i < data.list_promotion.length; i++) {
      data.list_promotion[i].checked = undefined;
    }
    state.checkoutInfo = data;
  },
  [GET_STAFF_BY_SERVICE](state, data) {
    state.staffList = data;
    let temp = [];
    if (data != null) {
      for (let i = 0; i < data.items.length; i++) {
        temp.push({ staff_id: data.items[i].employee_id, staff_name: data.items[i].employee.name, service_id: data.items[i].service_id })
      }
    }
    state.staffData = temp;
  },
  [GET_CHECKOUT_HISTORY](state, data) {
    state.checkoutHistory = data;
    let history_arr = [];
    if (data.items) {
      // for(let i = 0; i < data.items.length; i++) {
      //   history_arr.push(new History(data.items[i]));
      // }
      history_arr = data.items;
    }
    state.checkoutHistoryItems = history_arr;
  },
  [GET_CHECKOUT_HISTORY_SUMMARY](state, data) {
    state.historySummary = data;
  },
  [CHANGE_STATUS_PROMOTION](state, data) {
    for (let i = 0; i < state.checkoutInfo.list_promotion.length; i++) {
      if (state.checkoutInfo.list_promotion[i].id == data.id) {
        if (data.checked) {
          state.checkoutInfo.list_promotion[i].checked = false;
        } else {
          state.checkoutInfo.list_promotion[i].checked = true;
        }
        break;
      }
    }
  },
  [CHANGE_STATUS_REDEMPTION](state, data) {
    for (let i = 0; i < state.checkoutInfo.list_redeem.length; i++) {
      if (state.checkoutInfo.list_redeem[i].id == data.id) {
        if (data.checked) {
          state.checkoutInfo.list_redeem[i].checked = false;
        } else {
          state.checkoutInfo.list_redeem[i].checked = true;
        }
        break;
      }
    }
  },
  [PROMO_STATUS_UNDEFINED](state, data) {
    for (let i = 0; i < state.checkoutInfo.list_promotion.length; i++) {
      if (state.checkoutInfo.list_promotion[i].id == data.id) {
        state.checkoutInfo.list_promotion[i].checked = undefined;
        break;
      }
    }
  },
  [REDEMP_STATUS_UNDEFINED](state, data) {
    for (let i = 0; i < state.checkoutInfo.list_redeem.length; i++) {
      if (state.checkoutInfo.list_redeem[i].id == data.id) {
        state.checkoutInfo.list_redeem[i].checked = undefined;
        break;
      }
    }
  },
  [CHECK_UPDATE](state, data) {
    state.lastCheckinRecord = data;
  }








  // [CHANGE_STATUS_PROMOTION](state, data) {
  //   for(let i = 0; i < state.promotionList.length; i++) {
  //     if(state.promotionList[i].id == data.id) {
  //       if(data.checked) {
  //         state.promotionList[i].checked = false;
  //       } else {
  //         state.promotionList[i].checked = true;
  //       }
  //       break;
  //     }
  //   }
  // },
  // [CHANGE_STATUS_REDEMPTION](state, data) {
  //   for(let i = 0; i < state.redemptionList.length; i++) {
  //     if(state.redemptionList[i].id == data.id) {
  //       if(data.checked) {
  //         state.redemptionList[i].checked = false;
  //       } else {
  //         state.redemptionList[i].checked = true;
  //       }
  //       break;
  //     }
  //   }
  // },
  // [PROMO_STATUS_UNDEFINED](state, data) {
  //   for(let i = 0; i < state.promotionList.length; i++) {
  //     if(state.promotionList[i].id == data.id) {
  //       state.promotionList[i].checked = undefined;
  //       break;
  //     }
  //   }
  // },
  // [REDEMP_STATUS_UNDEFINED](state, data) {
  //   for(let i = 0; i < state.redemptionList.length; i++) {
  //     if(state.redemptionList[i].id == data.id) {
  //       state.redemptionList[i].checked = undefined;
  //       break;
  //     }
  //   }
  // }
}
